import { RegionShared } from "@1games-ru/region-shared";
import { FC, useMemo } from "react";
import clsx from "clsx";
import {
  BulletsIcon,
  GrenadelauncherIcon,
  MachineIcon,
  MachinepistolIcon,
  PistolIcon,
  Pumpshotgun,
  RpgIcon,
  SawnoffshotgunIcon,
  SniperrifleIcon,
  UnarmedIcon,
} from "@/shared/icons";
import { BaseIconProps } from "@/shared/icons/BaseIcon";
import { Weapon } from "@/domains/hud/constants/global";
import LinearIndicator from "@/domains/hud/components/indicator/LinearIndicator";

type Props = {
  className?: string;
} & (typeof RegionShared.Cef.Requests.SetHudStateRequest)["character"]["weapon"];

const icons: Record<Weapon, FC<BaseIconProps>> = {
  [Weapon.Machine]: MachineIcon,
  [Weapon.Rifle]: SniperrifleIcon,
  [Weapon.Machinepistol]: MachinepistolIcon,
  [Weapon.Pistol]: PistolIcon,
  [Weapon.Sawnoffshotgun]: SawnoffshotgunIcon,
  [Weapon.Pumpshotgun]: Pumpshotgun,
  [Weapon.Rpg]: RpgIcon,
  [Weapon.Grenadelauncher]: GrenadelauncherIcon,
  [Weapon.Sniperrifle]: SniperrifleIcon,
  [Weapon.Unarmed]: UnarmedIcon,
};

export default function HudWeapon({ className, value, cartridge, magazine }: Props) {
  const percent = useMemo(() => {
    try {
      if (cartridge && magazine) {
        return (cartridge / magazine) * 100;
      }
      return 0;
    } catch (e) {
      console.log(e);
      return 0;
    }
  }, [cartridge, magazine]);

  const WeaponIcon = icons[value];
  const showCartridge = cartridge !== undefined && value !== Weapon.Unarmed;

  return (
    <div
      className={clsx(
        "flex items-center w-[21.875rem] h-[3.625rem] p-4 gap-4",
        "bg-dark-900/60 rounded-[0.5rem]",
        className,
      )}
    >
      <WeaponIcon size={32} className="text-white shrink-0" />
      <LinearIndicator percent={percent} className="w-[10rem] h-[0.625rem]" />
      {showCartridge && (
        <div className="flex items-center gap-2">
          <BulletsIcon size={16} color="text-white" />
          <div className="flex items-center">
            <div className="font-bold text-white text-17">{cartridge}</div>
            <div className="font-medium text-white/50 text-15">/{magazine}</div>
          </div>
        </div>
      )}
    </div>
  );
}
